import { render, staticRenderFns } from "./OrderTotalsSummary.vue?vue&type=template&id=2e263558"
import script from "./OrderTotalsSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTotalsSummary.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports